/**
 * Guest Phone component
 */

import React from 'react';
import PropTypes from 'prop-types'
import * as FPT from '../utility/fpt'
import { StyleSheet, css } from 'aphrodite';
import PhoneNumber from '../components/PhoneNumber';
import PhoneType from '../components/phone-type';
import PhoneCountryCode from '../components/phone-country-code';
import { getCountryInfo } from '../utility/localizer'
import {
	formatPhone,
	validatePhone
} from '../utility/formator';
import _get from 'lodash/get';

class PhoneComponent extends React.Component {
    static propTypes = {
		handlePhoneInfo: PropTypes.func.isRequired,
		initialData: PropTypes.object,
		errorMessages: PropTypes.object,
		phoneNumberCountryCode: PropTypes.string,
		selectedCountry: PropTypes.string,
		isRequired: PropTypes.bool,
		examplePhoneNumbers: PropTypes.object,
		guestLabels: PropTypes.object,
		onRef: PropTypes.func,
	};

    constructor(props, context) {
        super(props, context);

        const {
			selectedCountry,
			phoneNumberCountryCode,
			phoneNumberPatternDesc = {},
			senderDetails = {}
		} = props

        const { maxLength = 10 } = phoneNumberPatternDesc.NATIONAL || {}
        const { phone_number = '' } = senderDetails.phone || {}
        const showCountryCode = getCountryInfo(selectedCountry).showPhoneCountryCode;

        this.state = {
			phoneNumberCountryCode,
			maxlength: parseInt(maxLength, 10),
			examplePhoneNumber: this.getExamplePhoneNumber('Mobile'), // Default format is mobile
			errMessagePhoneNumber: '',
			errMessagePhoneType: '',
			errMessagePhoneCountryCode: '',
			phone: phone_number,
			showCountryCode
		};
    }

    componentDidMount() {
		this.props.onRef(this)
	}

    componentWillUnmount() {
		this.props.onRef(undefined)
	}

    getExamplePhoneNumber = (phoneType) => {
		const generalPhoneNumber = _get(this.props.examplePhoneNumbers, 'GENERAL');
		switch(phoneType) {
			case 'Home':
				return _get(this.props.examplePhoneNumbers, 'FIXED_LINE', generalPhoneNumber);
				break;
			case 'Mobile':
				return _get(this.props.examplePhoneNumbers, 'MOBILE', generalPhoneNumber);
				break;
			case 'Work':
				return _get(this.props.examplePhoneNumbers, 'FIXED_LINE_OR_MOBILE', generalPhoneNumber);
				break;
			default: return generalPhoneNumber;
		}
	};

    /*
	* Handle focus on input
	*/
    handleFocus = (key) => {
		let ele = {}
		ele[key] = ''
		this.setState(ele)
	};

    /*
	* Handle phone number blur
	*/
    handlePhoneBlur = (phone, phoneCountryCode) => {
		if (!phone) {
			const { REQUIRED_PHONE_NUMBER = '' } = this.props.errorMessages
			this.setState({ errMessagePhoneNumber: REQUIRED_PHONE_NUMBER })
			FPT.trackError({ message: REQUIRED_PHONE_NUMBER, fieldId: 'phonenumber', code: 'REQUIRED_PHONE_NUMBER' });
			return;
		}

		const phoneDigits = phone
		const isPhoneNumberValid = validatePhone(phoneCountryCode, phone);
		if (!isPhoneNumberValid) {
			const { INVALID_PHONE_NUMBER = '' } = this.props.errorMessages
			this.setState({ errMessagePhoneNumber: INVALID_PHONE_NUMBER })
			return;
		}
	};

    /*
	* Handle phone number change
	*/
    handlePhoneNumber = (phoneNumber) => {
		this.setState({ phoneNumber: phoneNumber });
		this.handlePhoneInfo(this.state.phoneType, phoneNumber, this.state.countryCode);
	};

    /*
	* Handle phone type change
	*/
    handlePhoneType = (phoneType) => {

		this.setState({
			phoneType: phoneType,
			errMessagePhoneType: '',
			examplePhoneNumber: this.getExamplePhoneNumber(phoneType)
		});
		this.handlePhoneInfo(phoneType, this.state.phoneNumber, this.state.countryCode)
	};

    /*
	* Handle phone country code change
	*/
    handleCountryCode = (countryCode) => {
		this.setState({ countryCode: countryCode, errMessagePhoneCountryCode: '' })
		this.handlePhoneInfo(this.state.phoneType, this.state.phoneNumber, countryCode)
	};

    /*
	* Handle phone information
	*/
    handlePhoneInfo = (type = 'Mobile', number) => {
		const { phoneNumberCountryCode } = this.props;
		this.props.handlePhoneInfo({ type: type, number: number, countryCode: phoneNumberCountryCode })
	};

    /*
	* Handling required payment form fields
	*/
    handleRequiredFields = (params) => {
		const { errorMessages } = this.props
		let isValid = true
		let errMessagePhoneType, errMessagePhoneNumber, errMessagePhoneCountryCode
		let keysToValidate = Object.keys(params)

		keysToValidate.forEach((key) => {
			let value = params[key]

			switch (key) {
				case 'number':
					if (!value) {
						isValid = false;
						errMessagePhoneNumber = errorMessages.REQUIRED_PHONE_NUMBER;
						FPT.trackError({ message: errMessagePhoneNumber, fieldId: 'phonenumber', code: 'REQUIRED_PHONE_NUMBER' });
					}
					break;
				case 'countryCode':
					if (!value) {
						isValid = false;
						errMessagePhoneCountryCode = errorMessages.REQUIRED_PHONE_COUNTRY_CODE;
						FPT.trackError({ message: errMessagePhoneCountryCode, fieldId: 'countryCode', code: 'REQUIRED_PHONE_COUNTRY_CODE' });
					}
						break;
				default:
					break;
			}
		});

		if (!isValid) {
			this.setState({
				errMessagePhoneType, errMessagePhoneNumber, errMessagePhoneCountryCode,
			})
		}
		return isValid
	};

    /*
	* Handle phone number error
	*/
    handlePhoneError = (key) => {
		const { errorMessages } = this.props
		let errMessagePhoneNumber = errorMessages[key]
		this.setState({ errMessagePhoneNumber: errMessagePhoneNumber })
		FPT.trackError({ message: errMessagePhoneNumber, fieldId: 'phonenumber', code: key })
	};

    render() {
		const { guestLabels: { phone: phoneLabel, countryCode: countryCodeLabel, phoneType: phoneTypeLabel = '' } = {}, defaultNumber = {} } = this.props || {}
		const { showCountryCode = false } = this.state

		return (
            <div className="ppvx_row">
				<div className={this.state.showCountryCode ?
						"ppvx_col-md-6 ppvx_col-sm-6 ppvx_col-xs-6":
						"ppvx_col-md-4 ppvx_col-sm-4 ppvx_col-xs-4"}>
					<PhoneType
						{...this.props}
						label={phoneTypeLabel}
						value={defaultNumber.type}
						errorMessage={this.state.errMessagePhoneType}
						changePhoneType={this.handlePhoneType}/>
				</div>
				{showCountryCode && <div className="ppvx_col-md-6 ppvx_col-sm-6 ppvx_col-xs-6">
					<PhoneCountryCode
						{...this.props}
						label={countryCodeLabel}
						value={defaultNumber.countryCode}
						errorMessage={this.state.errMessageCountryCode}
						changeCountryCode={this.handleCountryCode}/>
				</div>}
				<div className={showCountryCode ?
						"ppvx_col-sm-12 padding_cc_lr_5 phone_holder":
						"ppvx_col-md-8 ppvx_col-sm-8 ppvx_col-xs-8 phone_holder"}>
					<PhoneNumber
						label={phoneLabel}
						value={defaultNumber.number}
						errorMessage={this.state.errMessagePhoneNumber}
						formator={formatPhone}
						validator={validatePhone}
						phoneCode={this.props.phoneNumberCountryCode}
						country={this.props.selectedCountry}
						maxlength={this.state.maxlength}
						showIsRequiredError={this.props.isRequired}
						exampleNumber={this.state.examplePhoneNumber}
						handleFocus={() => this.handleFocus('errMessagePhoneNumber')}
						handleBlur={this.handlePhoneBlur}
						changePhone={this.handlePhoneNumber}/>
				</div>
			</div>
        );
	}
}

export default PhoneComponent;
